/**
 * Created by Christal on 2018/5/14
 * 设置api请求的baseURL
 * 实际项目中建议该文件不纳入版本管理
 */
export default {
  baseURL: 'https://apiback.qiehuzhu.com'
  // baseURL: 'http://192.168.10.121:8088'
  // baseURL: 'http://localhost:8088'
  // baseURL: 'http://127.0.0.1:8088'
}



// WEBPACK FOOTER //
// ./src/api/env.js